import React from 'react';
import styles from './PrintableReport.module.css';
import { DateRange } from 'views/Analytics/AnalyticsMockService/Reporting/Pickers/BzmDateRangePicker/BzmDateRangePicker';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { formatDateAndTime } from 'utils/dateUtil';
import blazemeterLogo from 'assets/img/blazemeter_logo.png';
import { useTranslation } from 'react-i18next';

export const PRINTABLE_REPORT_ID = 'printable-report';

type PrintableReportProps = {
  reportName: string;
  reportDesc: string;
  serviceName: string;
  dateRange: DateRange;
  children: any;
};

/**
 * Wrapper for printing the report with the jsPDF & htmlToCanvas. It is positioned with absolute positioning so it
 * is not shown in the screen - it is offseted to -9999 pixels.
 * @constructor
 */
const PrintableReport = (props: PrintableReportProps) => {
  const { t } = useTranslation('analytics');

  return (
    <div id={PRINTABLE_REPORT_ID} className={styles.printableReport}>
      <div className="float-right text-right">
        <img src={blazemeterLogo} alt="BlazeMeter logo" width={200} />
      </div>
      <h1 className="mb-1">{props.reportName}</h1>
      <p className="mb-5">{props.reportDesc}</p>

      <Row className={styles.header}>
        <Col md={2}>
          <strong className="d-block mb-2">{t('printableReport.mockService')}</strong>
          {props.serviceName}
        </Col>

        <Col md={4}>
          <strong className="d-block mb-2">{t('printableReport.timeRangeSelection')}</strong>
          <span className="text-muted">{t('printableReport.from')}: </span>{' '}
          {props.dateRange.from ? formatDateAndTime(props.dateRange.from) : 'n/a'}
          <span className="text-muted ml-5">{t('printableReport.to')}: </span>{' '}
          {props.dateRange.to ? formatDateAndTime(props.dateRange.to) : 'n/a'}
        </Col>
      </Row>

      {/* Body */}
      {props.children}
      {/* ./Body */}

      <div className={styles.footer}>
        <span className="text-muted mr-3">
          {t('printableReport.dateGenerated')}: {formatDateAndTime(new Date())}
        </span>
      </div>
    </div>
  );
};

export default PrintableReport;
